import type { PartnerTradeStatus } from '@/entities/business-relationship/api/business-relationship.api';
import { formatMonthDay } from '@/shared/lib/format';
import { Badge } from '@/shared/ui';

interface TradeStatusBadgeProps {
  tradeStatus: PartnerTradeStatus;
  tradeStatusView: string;
  endedAt: string | null;
}

/** 거래 중(초록) · 거래 종료(회색, 종료일 MM.dd 함께) */
export function TradeStatusBadge({
  tradeStatus,
  tradeStatusView,
  endedAt,
}: TradeStatusBadgeProps) {
  if (tradeStatus === 'TRADING') {
    return <Badge tone="success">{tradeStatusView}</Badge>;
  }
  return (
    <Badge tone="neutral">
      {tradeStatusView}
      {endedAt && ` ${formatMonthDay(endedAt)}`}
    </Badge>
  );
}
